import { render } from "./page-internet-tariffs.vue?vue&type=template&id=289c0cb1&scoped=true"
import script from "./page-internet-tariffs.vue?vue&type=script&lang=js"
export * from "./page-internet-tariffs.vue?vue&type=script&lang=js"

import "./page-internet-tariffs.vue?vue&type=style&index=0&id=289c0cb1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-289c0cb1"]])

export default __exports__